export default __webpack_public_path__ + "static/media/screen_signin.617ce30b.png";